import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import messages from './messages';
import Grid from '../../components/Grid';
import './styles.css';
import Label from '../../components/Label';
import Icon from '../../components/Icon';

const localOnChange = (e, name, onChange, changed, setChanged) => {
  const { value } = e.target;
  setChanged(Object.assign(changed, { [name]: value }));
  onChange({ target: { value } }, name, false);
};

const onBlur = (e, name, intl, onChange, blurred, setBlurred, changed, setChanged) => {
  blurred[name] = true;
  setBlurred(Object.assign(blurred, { [name]: true }));
  /* istanbul ignore else */
  if (changed[name] !== undefined) {
    onChange({ target: { value: changed[name] } }, name, true);
    setChanged(Object.assign(changed, { [name]: '' }));
  }
};
/* istanbul ignore next */
const onFocus = (e, name, blurred, setBlurred, changed, setChanged) => {
  setChanged(Object.assign(changed, { [name]: e.target.value }));
  setBlurred(Object.assign(blurred, { [name]: false }));
};

const ScholarshipsInfo = ({ intl, url, addInfo, invalidUrl, onChange }) => {
  const [blurred, setBlurred] = useState({ url: false, addInfo: false });
  const [changed, setChanged] = useState({ url, addInfo });
  return (
    <Grid stackable width={14} styleName="merit-scholarships-general-info-grid">
      <Grid.Row>
        <Grid.Column width={3}>
          <FormattedMessage {...messages.meritScholarshipsGeneralInfoUrlLabel} />
        </Grid.Column>
        <Grid.Column computer={12} tablet={10}>
          <input
            styleName="merit-scholarships-general-info-input"
            key="merit-scholarships-general-info-scholarship-url"
            data-cy="merit-scholarships-general-info-scholarship-url"
            aria-label="Scholarships URL"
            value={url}
            placeholder={intl.formatMessage(messages.meritScholarshipsGeneralInfoUrlPlaceholder)}
            onChange={(e) => localOnChange(e, 'url', onChange, changed, setChanged)}
            onBlur={(e) => onBlur(e, 'url', intl, onChange, blurred, setBlurred, changed, setChanged)}
            onFocus={(e) => onFocus(e, 'url', blurred, setBlurred, changed, setChanged)}
            type="text"
          />
          {invalidUrl && (
            <Label role="tooltip" basic color="red" pointing data-cy="merit-scholarships-invalid-url-error">
              <Icon name="exclamation circle" styleName="validationError" size="large" />
              <FormattedMessage {...messages.meritScholarshipsInvalidUrl} />
            </Label>
          )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={3}>
          <FormattedMessage {...messages.meritScholarshipsGeneralInfoAdditionalInfoLabel} />
        </Grid.Column>
        <Grid.Column computer={12} tablet={10}>
          <textarea
            styleName="merit-scholarships-general-info-textarea"
            key="merit-scholarships-general-info-additional-info"
            data-cy="merit-scholarships-general-info-additional-info"
            aria-label="Additional information regarding scholarships"
            value={addInfo}
            placeholder={intl.formatMessage(messages.meritScholarshipsGeneralInfoAdditionalInfoPlaceholder)}
            onChange={(e) => localOnChange(e, 'addInfo', onChange, changed, setChanged)}
            onBlur={(e) => onBlur(e, 'addInfo', intl, onChange, blurred, setBlurred, changed, setChanged)}
            onFocus={(e) => onFocus(e, 'addInfo', blurred, setBlurred, changed, setChanged)}
            wrap="soft"
            type="text"
            rows={2}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row styleName="merit-scholarships-additional-info-sub-text-row">
        <Grid.Column width={3} />
        <Grid.Column computer={12} tablet={10}>
          <FormattedMessage {...messages.additionalInfoPlainText} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

ScholarshipsInfo.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  url: PropTypes.string,
  addInfo: PropTypes.string,
  invalidUrl: PropTypes.bool,
  onChange: PropTypes.func,
};

export default injectIntl(ScholarshipsInfo);
